/** Centralized feature flags derived from environment variables. */

export const featureFlags = {
  /** When false, hides all video avatar UI: create-echo video step, chat video toggle, my-echo idle/variant generation. */
  videoEnabled: import.meta.env['VITE_ENABLE_VIDEO'] === 'true',
} as const;
